import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PdfProjectStatusReportViewComponent } from './pdf-project-status-report-view.component';

const routes: Routes = [
  {
    path: '',
    component: PdfProjectStatusReportViewComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PdfProjectStatusReportViewRoutingModule { }
